import * as React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Link, NavLink, Redirect, withRouter} from "react-router-dom";
import assets from "game/app/assets";
import GameComponent from "game/app/components/game/game-component";
import Navbar from "./layout/navbar";
import Background from "./background";
import Notifications from "./layout/notifications";
import Footer from "./layout/footer";

class RulesPrimarySchool extends GameComponent {
    render () {
        const { currentGameId } = this.props;

        return (
            <div className='container'>
                <div className='row'>
                    <div className={this.mainContainerClass}>
                        <h1>Pravidla a základní principy on-line hry Rozpočti si to! 1. stupeň</h1>
                        <p>Co je finanční gramotnost a jak se chová finančně gramotný člověk? Kolik dospělý člověk utratí za základní výdaje a co se zbylými penězi, které vydělá? Jaké nástroje můžeme použít k finančnímu vzdělávání?</p>
                        <hr className='separate'/>
                        <h2>SMYSL A CÍL HRY</h2>
                        <p>Smyslem hry je seznámit vás se základními principy finanční gramotnosti a správného hospodaření.</p>
                        <p><strong>Cílem vaší hry je nasbírat co největší množství tzv. CHECHTÁKŮ</strong>, virtuálních zlatých herních mincí.</p>
                        <p>Úspěch ve hře záleží na vaší aktivitě a také na kvalitě zpracování jednotlivých úkolů.</p>
                        <hr className='separate'/>
                        <h2>CHECHTÁKY můžete získat za:</h2>
                        <ol>
                            <li className='separate-bottom'>
                                <p><strong>AKTIVITU</strong></p>
                                <p>Za každý úkol, který odevzdáte, získáte vždy alespoň nějaké chechtáky</p>
                                <p>Čím více úkolů zpracujete, tím více chechtáků získáte</p>
                            </li>
                            <li className='separate-bottom'>
                                <p><strong>KVALITU</strong></p>
                                <p>Čím větší práci si s úkolem dáte, tím více dostanete chechtáků</p>
                                <p>Zaměření na kvalitu zpracování jednotlivých úkolů vám pomůže proniknout hlouběji do témat finančního vzdělávání a rozvinout si další schopnosti a dovednosti</p>
                                <p><u>Kritéria</u>: forma zpracování úkolu (např. obrázky se cení víc), rozsah zpracování (je rozdíl, jestli pošlete jednu větu nebo jednu stránku)</p>
                            </li>
                        </ol>
                        <hr className='separate'/>
                        <h2>HODNOCENÍ</h2>
                        <p>Zpracované <strong>úkoly můžete posílat přes aplikaci až do konečného termínu soutěže</strong>, což je v tomto ročníku <strong>24. 5. 2019</strong></p>
                        <p>Jelikož jsou úkoly ve směs kreativní, hodnotí je <strong>živí hodnotitelé</strong>, proto může docházet k časové prodlevě mezi jejich odevzdáním a přidělením chechtáků, ta by ovšem neměla být delší než 1 týden.</p>
                        <p>Všechny přidělené chechtáky můžete vidět pod svým přístupem ve VYHODNOCENÍ.</p>
                        <hr className='separate'/>
                        <h2>PRŮBĚH HRY</h2>
                        <p><strong>Hra má 6 kategorií úkolů.</strong></p>
                        <ul>
                            <li><p><strong>Každá kategorie je zaměřena na jiné dovednosti,</strong> aby si každý přišel na své.</p></li>
                            <li><p><strong>Je jen na vás, které úkoly si zvolíte ke zpracování.</strong> Můžete udělat jen některé a zaměřit se hlouběji na znalosti nebo na jeden z výukových nástrojů. Pokud však chcete postoupit do finále, je potřeba zpracovat co nejvíce úkolů, abyste získali dostatečný počet chechtáků.</p></li>
                            <li><p><strong>Pořadí zpracování úkolů si volí každý tým sám.</strong></p></li>
                        </ul>

                        <div className='pt-4 pb-4'>
                            <div className='row'>
                                <div className='col-md-4'>
                                    <div className='card'>
                                        <div className='card-body text-center'>
                                            <img src={assets['zs_2019']['zs_2019_fin_gram']} className='img-fluid'/>
                                            <h5>FINANČNĚ GRAMOTNÝ ČLOVĚK</h5>
                                            <Link to={`/game/${currentGameId}/ukoly/1`} className='btn btn-primary'>Vstoupit</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div className='card'>
                                        <div className='card-body text-center'>
                                            <img src={assets['zs_2019']['zs_2019_vydaje']} className='img-fluid'/>
                                            <h5>ZÁKLADNÍ VÝDAJE V ROZPOČTU</h5>
                                            <Link to={`/game/${currentGameId}/ukoly/2`} className='btn btn-primary'>Vstoupit</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div className='card'>
                                        <div className='card-body text-center'>
                                            <img src={assets['zs_2019']['zs_2019_internet']} className='img-fluid'/>
                                            <h5>INTERNET A OBRÁZKY</h5>
                                            <Link to={`/game/${currentGameId}/ukoly/3`} className='btn btn-primary'>Vstoupit</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-4'>
                                    <div className='card'>
                                        <div className='card-body text-center'>
                                            <img src={assets['zs_2019']['zs_2019_psane_slovo']} className='img-fluid'/>
                                            <h5>PSANÉ SLOVO</h5>
                                            <Link to={`/game/${currentGameId}/ukoly/4`} className='btn btn-primary'>Vstoupit</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div className='card'>
                                        <div className='card-body text-center'>
                                            <img src={assets['zs_2019']['zs_2019_video']} className='img-fluid'/>
                                            <h5>VIDEO, PREZENTACE</h5>
                                            <Link to={`/game/${currentGameId}/ukoly/5`} className='btn btn-primary'>Vstoupit</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div className='card'>
                                        <div className='card-body text-center'>
                                            <img src={assets['zs_2019']['zs_2019_hry']} className='img-fluid'/>
                                            <h5>HRY A APLIKACE</h5>
                                            <Link to={`/game/${currentGameId}/ukoly/6`} className='btn btn-primary'>Vstoupit</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p><strong>Jak posílat zpracované úkoly:</strong></p>
                        <p>Zpracované úkoly posílejte přímo přes aplikaci, u každého úkolu je připraveno pole pro vložení textu a přílohy.</p>
                        <ul>
                            <li>
                                <p><strong>TEXTY</strong></p>
                                <p>posílejte buď v textovém dokumentu (popř. v pdf) jako přílohu, nebo text vložte přímo do pole pro zprávu</p>
                            </li>
                            <li>
                                <p><strong>OBRÁZKY a FOTKY</strong></p>
                                <p>posílejte jako přílohu, do těla zprávy napište, co posíláte</p>
                            </li>
                            <li>
                                <p><strong>VIDEA</strong></p>
                                <p>nahrajte na YouTube nebo cloudové úložiště a přes tělo zprávy pošlete odkaz + informaci, co posíláte</p>
                            </li>
                        </ul>

                        <hr className='separate'/>

                        <h2>ZÁKLADNÍ POPIS JEDNOTLIVÝCH KATEGORIÍ</h2>

                        <h5>FINANČNĚ GRAMOTNÝ ČLOVĚK</h5>
                        <p>Tato kategorie se zaměřuje na otázku, jak se chová finančně gramotný člověk. Úkolem je vytvořit medailonek dospělého finančně gramotného člověka.</p>
                        <p>Na rozehřátí je zde ještě úkol týkající se kapesného.</p>

                        <h5>ZÁKLADNÍ VÝDAJE V ROZPOČTU</h5>
                        <p>Tato kategorie se zaměřuje na základy rozpočtu domácnosti – během úkolů se zamyslíte nad tím, kolik stojí bydlení, jídlo a co dalšího si musí ještě dospělý člověk obstarat.</p>

                        <h5>INTERNET A OBRÁZKY</h5>
                        <p>První s kategorií zaměřených na výukové nástroje, ve které si přijdou na své ti, co rádi kreslí nebo něco graficky vytváří.</p>

                        <h5>PSANÉ SLOVO</h5>
                        <p>V této kategorii si vyzkoušíte najít a vysvětlit pojmy spojené s finanční gramotností a můžete si zkusit sami něco na toto téma napsat.</p>

                        <h5>VIDEO A PREZENTACE</h5>
                        <p>Dalšími výukovými nástroji jsou videa a prezentace. Můžeme se poučit s výukových videí nebo zkusit vytvořit svoje vlastní a tím se rozvinout v dalších dovednostech. Příprava tematické prezentace nebo scénky pro ostatní je z hlediska finančního vzdělávání k nezaplacení.</p>

                        <h5>HRY A APLIKACE</h5>
                        <p>Hry a aplikace mohou být dalším komplexním vzdělávacím nástrojem. Zahrajte si nějakou hru a sdílejte své zkušenosti nebo vytvořte svou vlastní hru.</p>

                        { currentGameId && <div className='separate text-center'><Link to={`/game/${currentGameId}`} className='btn btn-primary'>Zpět na přehled</Link></div> }
                    </div>
                </div>
            </div>
        );
    }
}

class RulesSecondarySchool extends GameComponent {
    render () {
        const { currentGameId } = this.props;

        return (
            <div className='container'>
                <div className='row'>
                    <div className={this.mainContainerClass}>
                        <h1>Pravidla a základní principy on-line hry Rozpočti si to! 2. stupeň</h1>
                        <p>Toto jsou pravidla on-line hry Rozpočti si to. Pokud se chcete podívat na pravidla soutěže Rozpočti si to, podívejte se zde: <a href='http://www.rozpoctisito.cz/rozpocti-si-to-2st/' target='_blank'>http://www.rozpoctisito.cz/rozpocti-si-to-2st/</a></p>
                        <p>Představte si, že jste hlavou rodiny a řešíte finanční zajištění celé domácnosti. Umíte si představit, co všechno musíte obstarat, aby mohli všichni členové domácnosti v klidu žít v dnešním světě? Co vše je potřeba zaplatit a kolik co stojí?</p>
                        <hr className='separate'/>
                        <h2>SMYSL A CÍL HRY</h2>
                        <p>Smyslem hry je seznámit vás s principem <strong>domácího hospodaření</strong> (rodinného rozpočtu), ukázat vám, co všechno si musí jedna domácnost obstarat, a kolik co stojí. Prožijete s ní kus života a budete muset udělat mnoho rozhodnutí.</p>
                        <p><strong>Cílem vaší hry je nasbírat co největší množství tzv. CHECHTÁKŮ</strong>, virtuálních zlatých herních mincí.</p>
                        <p>Úspěch ve hře záleží na vaší aktivitě a na zvolené STRATEGII. Rozhodnutí, která uděláte, mohou ovlivnit váš ROZPOČET i zisk chechtáků. Kromě toho musíte myslet ještě na jednu veličinu, a tou je SPOKOJENOST členů domácnosti.</p>
                        <hr className='separate'/>
                        <h2>CHECHTÁKY můžete získat za:</h2>
                        <ol>
                            <li className='separate-bottom'>
                                <p><strong>ZÁKLADNÍ úkoly</strong></p>
                                <p>jejich <strong>splnění je nutné pro další postup ve hře</strong></p>
                                <p>Při plnění základních úkolů můžete získat další chechtáky za taková rozhodnutí, která značí <strong>zdravé finanční návyky, aktivní přístup k životu, zdravý životní styl apod.</strong> Chechtáky jsou také hodnoceny varianty, které podporují vzdělávání či rozšiřují možnosti přístupu k informacím.</p>
                            </li>
                            <li className='separate-bottom'>
                                <p><strong>KREATIVNÍ úkoly</strong></p>
                                <p>jsou dobrovolné, můžete však za ně získat další chechtáky</p>
                                <p>jsou zaměřeny na <strong>tvořivost</strong> a <strong>pomáhají vám lépe se vžít do vaší rodiny</strong> / domácnosti</p>
                                <p><i>POZOR! Kreativní úkoly patří k základním úkolům jako jejich rozšíření, proto je možné je odevzdat <strong>pouze do konce daného kola hry</strong>.</i></p>
                            </li>
                            <li className='separate-bottom'>
                                <p><strong>BONUSOVÉ úkoly</strong></p>
                                <p>jsou také dobrovolné, je v nich však skryto největší množství chechtáků</p>
                                <p>v bonusových úkolech je oceněna vaše AKTIVITA dál se finančně vzdělávat a rozvíjet související kompetence.</p>
                                <p>zaměřují se na různé <strong>výukové nástroje, rozšiřují znalosti a rozvíjejí tvořivost</strong></p>
                                <p>pomocí nich si každý tým může určit vlastní hloubku i šířku svého finančního vzdělávání</p>
                                <p><i>Bonusové úkoly jsou <strong>dostupné po celou dobu trvání on-line části soutěže</strong>. Je možné je plnit nezávisle na základních úkolech, a proto je možné je odevzdávat i poté, co dokončíte základní úkoly.</i></p>
                            </li>
                            <li className='separate-bottom'>
                                <p><strong>SPOKOJENOST</strong></p>
                                <p>na konci každého kola se vám vypočítá úroveň spokojenosti domácnosti</p>
                                <p>spokojenost záleží na tom, jak často volíte možnosti, které by zpravidla zvolily i jiné rodiny s obdobnými příjmy nebo profesemi – doporučené varianty jsou označené.</p>
                                <p><strong>konečná spokojenost bude na konci hry přepočtena na chechtáky</strong></p>
                            </li>
                            <li className='separate-bottom'>
                                <p><strong>vytvořená FINANČNÍ REZERVA na konci hry – index finanční rezervy</strong></p>
                                <p>na konci každého kola vidíte svůj <strong>index finanční rezervy</strong> – není ovšem důležité, jak vysoký je v průběhu hry, důležité je, jak vypadá <strong>na konci hry</strong>, kdy bude přepočítán na chechtáky</p>
                                <p>toto číslo ukazuje, jak velkou finanční rezervu se vám podařilo během 1 roku vybudovat, počítá se jako poměr kumulovaného cashflow a průměrného příjmu rodiny</p>
                                <p><i>Příklad: index finanční rezervy = 2,5 znamená, že máte na konci roku vytvořenou rezervu 2 a půlnásobek průměrných příjmů domácnosti</i></p>
                            </li>
                        </ol>
                        <hr className='separate'/>
                        <h2>HODNOCENÍ</h2>
                        <p>Chechtáky za <strong>základní úkoly, spokojenost a finanční rezervu</strong> přiděluje systém (aplikace) <strong>automaticky</strong>.</p>
                        <p><strong>Kreativní a bonusové úkoly</strong> hodnotí <strong>živí hodnotitelé</strong>, proto může docházet k časové prodlevě mezi jejich odevzdáním a přidělením chechtáků, ta by ovšem neměla být delší než 1 týden.</p>
                        <p>Všechny přidělené chechtáky můžete vidět pod svým přístupem ve VYHODNOCENÍ.</p>
                        <hr className='separate'/>
                        <h2>PRŮBĚH HRY</h2>
                        <p><strong>Hra má 3 kola</strong>, kterými je nutné projít.</p>
                        <ul>
                            <li>
                                <p>Do dalšího kola můžete postoupit po splnění všech základních úkolů.</p>
                                <ul>
                                    <li>proto je na začátku vstup do 2. a 3. kola neaktivní.</li>
                                </ul>
                            </li>
                            <li>
                                <p>Kreativní úkoly, které náležejí k danému kolu, musíte odevzdat dříve, než kolo ukončíte.</p>
                                <ul>
                                    <li>v každém kole je ovšem možné nejdříve vyřešit základní úkoly, poté pracovat na kreativních úkolech a následně teprve uzavřít kolo</li>
                                </ul>
                            </li>
                            <li>
                                <p>Kreativní a bonusové úkoly nahrávejte přímo do aplikace</p>
                                <ul>
                                    <li>je možné nahrát různé formáty (text, obrázek, pdf...). Videa je zapotřebí nahrát na youtube.com a do aplikace vložit odkaz</li>
                                    <li>v rámci 1 úkolu je možné nahrávat výtvory opakovaně – odměněny budou všechny výtvory až do max. možného zisku chechtáků, popř. bude vyhodnocena nejlepší verze</li>
                                </ul>
                            </li>
                        </ul>

                        <div className='row text-center aligned-lg separate'>
                            <div className='col-lg-4'>
                                <div className='card aligned-card'>
                                    <div className='card-body'>
                                        <img src={assets.kolo_1} className='img-fluid'/>
                                        <h3>Profil</h3>
                                        <p className='fill'>V prvním kole si určíte, jak bude vypadat vaše rodina či domácnost, kde budete bydlet, vyřešíte si dopravu či jídlo.</p>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-4'>
                                <div className='card aligned-card'>
                                    <div className='card-body'>
                                        <img src={assets.kolo_2} className='img-fluid'/>
                                        <h3>Výdaje</h3>
                                        <p className='fill'>V druhém kole se podíváme na další výdaje, se kterými je potřeba počítat. A také budete čelit neplánovaným životním situacím, které se vám přihodily.</p>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-4'>
                                <div className='card aligned-card'>
                                    <div className='card-body'>
                                        <img src={assets.kolo_3} className='img-fluid'/>
                                        <h3>Vánoce a rezervy</h3>
                                        <p className='fill'>Poslední kolo je věnované Vánočním svátkům, možnosti přivýdělku a spoření a investicím.</p>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <hr className='separate'/>

                        <h2>Obecné principy</h2>
                        <p>Během hry musíte pracovat s dvěma základními surovinami, kterými jsou <strong>PENÍZE</strong> a <strong>SPOKOJENOST</strong>. Budete vystaveni rozhodnutím, kdy se mezi těmito hodnotami budete muset rozhodnout. Je zapotřebí je průběžně dobře vyvažovat.</p>
                        <p>Peníze se promítají do ročního <strong>ROZPOČTU DOMÁCNOSTI</strong>, ke kterému se dostanete z horního menu. Do rozpočtu se vám postupně zapisují jednotlivé položky, které si vybíráte. V rozpočtu vidíte i celkové součty položek za celý rok, výsledky (příjmy – výdaje) za měsíc a kumulované cashflow za celý rok.</p>
                        <ul>
                            <li>
                                <p><strong>Na konci prvního kola vám musí v rozpočtu zbývat alespoň 45 000 Kč</strong> k pokrytí výdajů druhého kola. <strong>Na konci druhého kola se nesmíte dostat do celkového mínusu = BANKROT</strong>, tzn. že v závěru druhého kola nesmí být kumulované cashflow menší než nula. Pokud máte v rozpočtu při ukončování kola nižší částku, než je uvedeno, není umožněno kolo uzavřít a je potřeba, abyste se ke svým odpovědím vrátili a upravili zvolené možnosti tak, aby byl rozpočet v plusu.  Pokud se do celkového mínusu dostanete po zkoušce “Co život dal” v závěru druhého kola, je potřeba se vrátit zpět k dříve zvoleným odpovědím v tomto kole a upravit váš rozpočet. V tomto případě ale přijdete o 10 chechtáků.</p>
                            </li>
                            <li><p>K rozpočtu se nejlépe dostanete z horního navigačního menu.</p></li>
                        </ul>
                        <p><strong>INDEX FINANČNÍ REZERVY</strong> udává, jak velkou finanční rezervu se vám daří tvořit. Počítá se vždy na konci kola, podstatný je však konečný výsledek na konci hry (3. kola). Podle konečného výsledku budou týmu přiděleny chechtáky. Čím vyšší index, tím dostanete více chechtáků, měli byste se tedy snažit vytvořit co největší finanční rezervu (ale pozor na spokojenost domácnosti – viz dále).</p>
                        <p>Výdaje, které si budete během hry vybírat, mohou být pravidelné nebo jednorázové.</p>
                        <p><strong>PRAVIDELNÉ VÝDAJE</strong> se do tabulky rozpočtu k dané položce automaticky zapisují do každého měsíce roku. U většiny <strong>JEDNORÁZOVÝCH VÝDAJŮ</strong> se můžete rozhodnout, do jakého měsíce výdaj umístíte. U některých jednorázových výdajů je však předem dáno zadáním, do kterého měsíce / měsíců se zapíše.</p>
                        <p><strong>SPOKOJENOST</strong> domácnosti se mění vždy na konci kola, kdy ji systém vypočítá na základě vašich odpovědí. Doporučené odpovědi jsou označené.</p>

                        <hr className='separate'/>

                        <h2>ZÁKLADNÍ POPIS JEDNOTLIVÝCH ÚKOLŮ</h2>
                        <h3>1. kolo – PROFIL</h3>
                        <p>V prvním kole si určíte, jak vypadá vaše rodina či domácnost, kde bydlíte, co jíte, čím jezdíte. Začnete výběrem domácnosti - vyberete si klasickou rodinu, samoživitele, domácnost s prarodičem či 4 studenty žijící v jedné domácnosti?</p>
                        <p>Kromě složení členů domácnosti si vybíráte i další základní nastavení. Konkrétní domácnost vám poté systém vylosuje.</p>

                        <div className='card separate'>
                            <div id="family-picker">
                                <div className="left-side">
                                    <div className="title">Složení domácnosti</div>
                                    <ul>
                                        <li className="selected">4 studenti žijící v jedné domácnosti</li>
                                        <li className="inactive">rodič samoživitel + 3 děti</li>
                                        <li className="inactive">máma + táta + 2 děti</li>
                                        <li className="inactive">rodič + prarodič + 2 děti</li>
                                        <li className="inactive">máma + táta + prarodič + 1 dítě</li>
                                    </ul>
                                </div>
                                <div className="right-side">
                                    <div className="title">Členové rodiny</div>
                                    <ul>
                                        <li className="selected">Jeden student pracuje na plný úvazek</li>
                                        <li className="inactive">Všichni studenti mají brigádu</li>
                                        <li className="inactive">Studenti společně podnikají</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="card-body text-center">
                                <p className="text-danger"><strong>Pozor, vylosovanou domácnost si nemůžete změnit.<br/>Opravdu chcete domácnost losovat ze zobrazené varianty?</strong></p>
                                <button disabled="" className="btn btn-primary wide-btn">Potvrdit výběr</button>
                            </div>
                        </div>

                        <p>Po výběru domácnosti vidíte podrobnější popis vaší domácnosti a dozvíte se, jak vysoké má vaše rodina / domácnost pravidelné <strong>PŘÍJMY</strong> a jak vysokou <strong>POČÁTEČNÍ FINANČNÍ REZERVU</strong> máte vytvořenou.</p>
                        <p>V úvodním kole musíte dále vyřešit 3 kategorie úkolů: <strong>BYDLENÍ, JÍDLO, DOPRAVA</strong>. K bydlení a dopravě patří ještě výběr pojištění.</p>
                        <p>Minimální částka zůstatku kumulovaného cashflow (Peníze) pro ukončení výběru základních výdajů je 45 000 Kč. To je zůstatek, který je potřebný k pokrytí dalších výdajů v průběhu 2. a 3. kola. V případě nižšího zůstatku není umožněno výběr základních výdajů dokončit.</p>
                        <div className="row separate text-center">
                            <div className="col-sm-4">
                                <img src={ assets.bydleni } className="img-fluid"/>
                            </div>
                            <div className="col-sm-4">
                                <img src={ assets.jidlo } className="img-fluid"/>
                            </div>
                            <div className="col-sm-4">
                                <img src={ assets.doprava } className="img-fluid"/>
                            </div>
                        </div>
                        <p>Na některé z vás čekají na konci kola SPECIFICKÉ UDÁLOSTI. Těmto událostem budete vystaveni jenom v případě výběru některých položek bydlení a dopravy.</p>

                        <h3>2. kolo – PRAVIDELNÉ A JEDNORÁZOVÉ VÝDAJE</h3>
                        <p>Ve 2. kole si vyberete výdaje, které se spojují s tím, co vaše domácnost má a co dělá. Budete se zamýšlet celkem na 7 kategoriemi: <strong>DOMÁCNOST, PÉČE O SEBE, KOMUNIKACE A MÉDIA, ZDRAVÍ A SPORT, VZDĚLÁVÁNÍ A ROZVOJ, PÉČE O ZVÍŘE</strong> a <strong>ZÁBAVA</strong>.</p>

                        <div className="row aligned-lg separate">
                            <div className="col-md-6 col-lg-4 text-center separate-bottom-grid">
                                <div className="card aligned-card">
                                    <div className="card-body"><img src={ assets.categories.domacnost} className="img-fluid"/><h5>Domácnost</h5><p className="fill">Vyberte si, jak se budete starat o svou domácnost a jak ji vybavíte.</p></div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 text-center separate-bottom-grid">
                                <div className="card aligned-card">
                                    <div className="card-body"><img src={assets.categories.pece_o_sebe} className="img-fluid"/><h5>Péče o sebe</h5><p className="fill">Je potřeba se starat nejen o domácnost, ale i o sebe.</p></div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 text-center separate-bottom-grid">
                                <div className="card aligned-card">
                                    <div className="card-body"><img src={assets.categories.komunikace_a_media} className="img-fluid"/><h5>Komunikace a média</h5><p className="fill">Vyberte si telefon, tarif, počítač a další vybavení, které budete používat.</p></div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 text-center separate-bottom-grid">
                                <div className="card aligned-card">
                                    <div className="card-body"><img src={assets.categories.zdravi_a_sport} className="img-fluid"/><h5>Zdraví a sport</h5><p className="fill">Rozmyslete si, jak se budete udržovat fit a nastavte si to v této kategorii.</p></div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 text-center separate-bottom-grid">
                                <div className="card aligned-card">
                                    <div className="card-body"><img src={assets.categories.vzdelavani_a_rozvoj} className="img-fluid"/><h5>Vzdělávání a rozvoj</h5><p className="fill">Budou děti chodit na kroužky? A budou se dále vzdělávat i dospělí členové domácnosti?</p></div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 text-center separate-bottom-grid">
                                <div className="card aligned-card">
                                    <div className="card-body"><img src={assets.categories.pece_o_zvire} className="img-fluid"/><h5>Péče o zvíře</h5><p className="fill">Budou děti chodit na kroužky? A budou se dále vzdělávat i dospělí členové domácnosti?</p></div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 text-center separate-bottom-grid">
                                <div className="card aligned-card">
                                    <div className="card-body"><img src={assets.categories.zabava} className="img-fluid"/><h5>Zábava</h5><p className="fill">Vyražte si občas ven. Bude to bavit dospělé i děti a zvedne vám to náladu.</p></div>
                                </div>
                            </div>
                            <div className="col-lg-8 text-center">
                                <div className="card">
                                    <div className="card-body"><img
                                        src="/packs/images/game/categories/co_zivot_dal-fdfeccf4f93741d7eb08d365a6f6234c.png" className="img-fluid"/><h5>Co život dal</h5><p>V okamžiku, kdy máte nastavené výdaje ve všech kategoriích výše, můžete si vyzkoušet, co na vás přichystal život. Ale pozor, pokud se do toho pustíte, nebudete se už moct vrátit zpátky a změnit své dřívější odpovědi.</p></div>
                                </div>
                            </div>
                        </div>

                        <p>Na závěr 2. kola zkusíte své štěstí v událostech CO ŽIVOT DAL, které prověří připravenost vašeho rozpočtu na nečekané události.</p>

                        <h3>3. KOLO – VÁNOCE A FINANČNÍ REZERVY</h3>
                        <p>Třetí kolo je rozděleno na dvě části. První část se věnuje tématu VÁNOCE a ukazuje, kolik nás tyto svátky mohou stát. Na druhou stranu také dává příležitost přivydělat si další korunky – musíte tedy vyřešit kategorie VÁNOČNÍ PŘIVÝDĚLKY A VÁNOČNÍ VÝDAJE.</p>
                        <p>Druhá část se věnuje tématu FINANČNÍ REZERVY a vy si můžete naplánovat, kolik si pravidelně budete odkládat na krátkodobé rezervy a kolik na investice a tvorbu dlouhodobých rezerv.</p>
                        <p>Pravidla soutěže Rozpočti si to vztahující se k aktuálnímu ročníku jsou uvedeny zde: <a href='http://www.rozpoctisito.cz/rozpocti-si-to-2st/' target='_blank'>http://www.rozpoctisito.cz/rozpocti-si-to-2st/</a>.</p>

                        <hr className='separate'/>

                        { currentGameId && <div className='text-center'><Link to={`/game/${currentGameId}`} className='btn btn-primary'>Zpět na přehled</Link></div> }
                        { currentGameId && <hr className='separate'/> }

                        <h2>SLOVNÍČEK POJMŮ</h2>

                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong></strong></p>
                            </div>
                            <div className='col-lg-8'>

                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Rodinný rozpočet / rozpočet domácnosti</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                plán finančního hospodaření rodiny (domácnosti)
                                Jeho vytvoření vede k získání kontroly nad finanční situací rodiny a ke snížení rizika jejích zbytečných výdajů a případného zadlužování. Lze tím najít zdroje pro rezervy a úspory v rodinném rozpočtu a připravit se tak na nečekané výdaje.
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong></strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p></p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Aktivní příjem</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>takový příjem, který získáváme svou aktivitou, měníme svůj čas za peníze (zaměstnání, živnost, brigády apod.)</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Pasivní příjem</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>pravidelný příjem (nejčastěji 1x měsíčně nebo 1x ročně), který nám plyne, aniž bychom pro něj museli vynakládat další aktivitu. Buduje se pomocí investic – finančních a/nebo časových. Jedná se kupříkladu o nájem z nemovitosti či podíl na zisku (z akcií, z podílových fondů, z vlastního podnikání či z investic do podnikání jiných apod.).</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>OSVČ</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>= osoba samostatně výdělečně činná – je malý podnikatel, který vydělává tzv. „sám na sebe“.</p>
                                <p>Nejčastěji živnostník, ale za OSVČ mohou být brána i svobodná povolání (umělci apod.) …</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Hrubý příjem vs. čistý příjem</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>hrubý příjem je dán pracovní smlouvou.</p>
                                <p>
                                    - mínus zdravotní pojištění<br/>
                                    - mínus sociální pojištění<br/>
                                    - mínus daň z příjmu<br/>
                                    = čistý příjem
                                </p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Zdravotní pojištění (ZP)</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>Na veřejné zdravotní pojištění musí přispívat každý, ať vydělává či nikoliv (výjimku tvoří studenti, důchodci a další cílové skupiny, za které platí ZP stát).</p>
                                <p>Peníze z pojištění jdou zdravotním pojišťovnám a ty z nich financují veřejnou zdravotní péči.</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Sociální pojištění</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>Příspěvek na sociální pojištění odvádí každý zaměstnanec (a zaměstnavatel za zaměstnance) i živnostník. Je dán zákonem jako určité procento z příjmů.</p>
                                <p>Z vybraných peněz jsou financovány důchody a sociální dávky.</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Daň z příjmu</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>Daň z příjmů fyzických osob se odečítá každému zaměstnanci z příjmu, OSVČ podávají 1x ročně daňové přiznání, kde spočítají daň za celý rok.</p>
                                <p>Daň z příjmů je tzv. přímou daní a je jedním z hlavních příjmů státního rozpočtu.</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Důchod (starobní důchod)</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>měsíční částka, na kterou má nárok každý, kdo splnil podmínku minimální doby pojištění a dosáhl důchodového věku. Výše důchodu závisí na tom, jak dlouho důchodce pracoval a kolik celkem vydělal (odvedl na sociální pojištění)</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Počáteční finanční rezerva</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>množství peněz, které máme uloženy jako rezervu na horší časy na začátku hry – ve hře se jedná o peníze na běžném účtu (popř. v trezoru apod.) na začátku roku</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Výdaje (do „pasiv“)</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>finanční prostředky vynaložené ke spotřebě, které se již nevrátí</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Povinné výdaje</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>musíme platit ze zákona nebo díky smluvnímu zajištění (např. daně, úvěry apod.).</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Nutné výdaje</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>musíme platit, abychom přežili (např. jídlo, bydlení apod.), lze je však optimalizovat.</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Zbytné výdaje</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>Bez zbytných výdajů se obejdeme (např. zábava apod.), a proto by měly být první na řadě, pakliže musíme v rámci výdajů škrtat.</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Pravidelné výdaje</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>Výdaje, které máme opakovaně každý měsíc. Jejich výše je buď přesně dána (např. nájemné, splátka úvěru, platba za internet …) nebo ji pro potřeby domácího rozpočtu odhadujeme jako průměrnou měsíční částku.</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Jednorázové výdaje</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>Výdaje, které máme jednorázově (např. nákup televize) nebo jednou za čas (např. výlet).</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Investice (do „aktiv“)</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>finanční prostředky vynaložené tak, aby generovaly zisk nebo pasivní příjem – tj. očekáváme zvýšení jejich hodnoty (akcie; podílové fondy; dluhopisy; nemovitosti; drahé kovy, obrazy a jiná umělecká díla……)</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Krátkodobá finanční rezerva</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>úspora finančních prostředků, která slouží na pokrytí nečekaných výdajů</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Dlouhodobá finanční rezerva</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>úspora, která slouží k zajištění prostředků pro budoucí sny a cíle – tvoří se nejčastěji pomocí investic</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Cashﬂow - tok peněz</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>rozdíl mezi příjmy a výdaji. Tok peněz musíme sledovat, abychom se nedostali „do mínusu“ a měli vždy v daném okamžiku prostředky na pokrytí výdajů (a investic).</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong></strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p></p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Kumulované cashflow</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>Pokud máme vytvořenou finanční rezervu, můžeme se jednorázově v některém z měsíců dostat do mínusu. Ve hře je ovšem sledováno také tzv. kumulované cashflow, které započítává i počáteční rezervu a přebytky či schodky rozpočtu.</p>
                                <p>Kumulované cashflow nesmí být nikdy záporné! Pokud se domácnost dostane do záporného kumulovaného cashflow na konci kola, znamená to, že zbankrotovala, nemá dost peněz na pokrytí všech výdajů a investic.</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Úvěr</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>Půjčka peněz za úplatu (úrok).</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Hypotéka</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>spotřebitelský úvěr na bydlení (koupě, výstavba, rekonstrukce …) – zajištěný nemovitostí (zástavním právem)</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong>Sdílená ekonomika</strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p>Mezi nejběžnější formy sdílení majetku u nás je opakovaný pronájem nemovitostí v období, kdy jej nepotřebujeme. Například pokud máte chatu, kam jezdíte jen jednou do roka, můžete jí po zbytek roku pronajímat případným zájemcům.</p>
                                <p>Obdobně to může fungovat například s autem, které budete potřebovat jen v určité dny. Ty ostatní jej pronajímáte.</p>
                                <p>Sdíleným užíváním majetku se zabývají různé start-upy a úspěšné projekty.</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong></strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p></p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <p><strong></strong></p>
                            </div>
                            <div className='col-lg-8'>
                                <p></p>
                            </div>
                        </div>
                        { currentGameId && <div className='separate text-center'><Link to={`/game/${currentGameId}`} className='btn btn-primary'>Zpět na přehled</Link></div> }
                    </div>
                </div>
            </div>
        );
    }
}

class Rules extends GameComponent {

    componentDidMount() {
        this.setTitle('Pravidla');
    }

    componentWillUnmount() {
        this.setTitle();
    }

    render() {
        let currentGameId = this.props.gameInstance.instance && this.getInstanceId();
        const rulesPage = this.props.location.state && this.props.location.state.rules || 'secondary';
        let rules = null;
        let rulesProps = { currentGameId: currentGameId, gameInstance: this.props.gameInstance };

        switch (rulesPage) {
            case 'primary':
                rules = <RulesPrimarySchool {...rulesProps }/>;
                break;

            case 'secondary':
            default:
                rules = <RulesSecondarySchool {...rulesProps }/>;
                break;
        }

        return (
            <div id='body-container' className={this.props.mainClass}>
                <Navbar>
                    <div className='bottom-menu'>
                        <ul className='navbar-nav'>
                            <li className={`nav-item ${ rulesPage === 'secondary' ? 'active' : '' }`}><Link className='nav-link' to={{pathname: '/pravidla', state: { rules: 'secondary' }}}>Pravidla pro 2. stupeň</Link></li>
                            <li className={`nav-item ${ rulesPage === 'primary' ? 'active' : '' }`}><Link className='nav-link' to={{pathname: '/pravidla', state: { rules: 'primary' }}}>Pravidla pro 1. stupeň</Link></li>
                        </ul>
                    </div>
                </Navbar>
                <div className='clearfix'>&nbps;</div>
                <div id='main-container' className={'content'}>
                    <Background/>
                    <Notifications/>
                    { rules }
                </div>
                <Footer/>
            </div>
        );

        // return (<RulesSecondarySchool currentGameId={currentGameId} gameInstance={this.props.gameInstance}/>);
    }
}

function mapStateToProps(state,ownProps) {
    return {
        auth: state.auth,
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({}, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(Rules));
